import {withStyles, withStylesCompose} from '../withStyles';
import {Noop} from '../noop';
import styles from './styles.module.scss';
/**
 * Used in order to bundle everything together with a single component.
 * We can use this hoc in order to style font properties of each element passed, and avoid duplications.
 * */
const withNormalWeight = (Component = Noop) => withStyles(Component, styles, 'font-weight-normal');
const withBoldWeight = (Component = Noop) => withStyles(Component, styles, 'font-weight-bold');
const withXBoldWeight = (Component = Noop) => withStyles(Component, styles, 'font-weight-xbold');
const withUppercase = (Component = Noop) => withStyles(Component, styles, 'base-uppercase');
const withUppercaseBold = (Component = Noop) =>
  withStyles(Component, styles, 'base-uppercase-bold');
const withUppercaseXBold = (Component = Noop) =>
  withStyles(Component, styles, 'base-uppercase-xbold');
const withUnderline = (Component = Noop) => withStyles(Component, styles, 'underlined');
const withItalic = (Component = Noop) => withStyles(Component, styles, 'italic');
const withXxsmall = (Component = Noop) => withStyles(Component, styles, 'xxxsmall');
const withPSmall = (Component = Noop) => withStylesCompose(Component, styles, ['p', 'small']);
const withPSmallLh = (Component = Noop) =>
  withStylesCompose(Component, styles, ['p', 'small-lh-xs']);
const withPSmallLhBase = (Component = Noop) =>
  withStylesCompose(Component, styles, ['p', 'small-lh-base']);
const withH1NoMargin = (Component = Noop) =>
  withStylesCompose(Component, styles, ['h1', 'no-margin']);
const withH2NoMargin = (Component = Noop) =>
  withStylesCompose(Component, styles, ['h2', 'no-margin']);
const withPNoMargin = (Component = Noop) =>
  withStylesCompose(Component, styles, ['p', 'no-margin']);
const withPSmallLhBaseNoMargin = (Component = Noop) =>
  withStylesCompose(Component, styles, ['p', 'small-lh-base', 'no-margin']);
const withPMarginTMd = (Component = Noop) =>
  withStylesCompose(Component, styles, ['p', 'margin-t-md-p']);
const withPMarginSm = (Component = Noop) =>
  withStylesCompose(Component, styles, ['p', 'margin-b-sm']);
const withPMarginMd = (Component = Noop) =>
  withStylesCompose(Component, styles, ['p', 'margin-b-md']);
const withH2Smaller = (Component = Noop) => withStyles(Component, styles, 'h2-smaller');
const withSecondaryFont = (Component = Noop) => withStyles(Component, styles, 'secondary-font');
const withSecondaryFontTestimonial = (Component = Noop) =>
  withStyles(Component, styles, 'secondary-font--testimonial');

/**
 * Redesign 2024
 * */
const withH1Small = (Component = Noop) => withStyles(Component, styles, 'h1-font-size-sm');
const withHomeSubP = (Component = Noop) => withStyles(Component, styles, 'homepage-sub-p');
const withHeadingEyebrow = (Component = Noop) => withStyles(Component, styles, 'heading-eyebrow');
const withXSmall = (Component = Noop) => withStyles(Component, styles, 'xsmall-font');
const withSmall = (Component = Noop) => withStyles(Component, styles, 'small-font');
const withPSmallMarginSm = (Component = Noop) =>
  withStylesCompose(Component, styles, ['p', 'small-margin-sm']);
const withMd = (Component = Noop) => withStyles(Component, styles, 'md-font');
const withMark = (Component = Noop) => withStyles(Component, styles, 'mark');
const withDotCavoWaters = (Component = Noop) =>
  withStyles(Component, styles, 'with-dot--cavowaters');
const withDotYellow400 = (Component = Noop) => withStyles(Component, styles, 'with-dot--yellow400');
const withDotNeonVioletFlowers = (Component = Noop) =>
  withStyles(Component, styles, 'with-dot--neonvioletflowers');
const withDotNeonAegeanSea = (Component = Noop) =>
  withStyles(Component, styles, 'with-dot--neonaegeansea');

export {
  withNormalWeight,
  withBoldWeight,
  withXBoldWeight,
  withUppercase,
  withUppercaseBold,
  withUppercaseXBold,
  withUnderline,
  withItalic,
  withXxsmall,
  withPSmall,
  withPSmallLh,
  withPSmallLhBase,
  withH1NoMargin,
  withH2NoMargin,
  withPNoMargin,
  withPSmallLhBaseNoMargin,
  withPMarginTMd,
  withPMarginSm,
  withPMarginMd,
  withH2Smaller,
  withSecondaryFont,
  withSecondaryFontTestimonial,
  /**
   * Redesign 2024
   * */
  withH1Small,
  withHomeSubP,
  withHeadingEyebrow,
  withXSmall,
  withSmall,
  withPSmallMarginSm,
  withMd,
  withMark,
  withDotCavoWaters,
  withDotYellow400,
  withDotNeonVioletFlowers,
  withDotNeonAegeanSea
};
